import React from 'react';
import PropTypes from 'prop-types';
import Image from "../../Common/components/Image";
import {getPrimaryMediaWidget, spreadWidget} from "sportinglife-react-common/widgets";
import {get} from "lodash";
import {connect} from "react-redux";
import Ooyala from "../../Ooyala/component/Ooyala";
import {withErrorBoundary} from "../../Errors/components/withErrorBoundry";

export const ArticleHeroImage = ({widgets, media}) => {
  const primaryWidget = spreadWidget(getPrimaryMediaWidget(widgets));

  if (primaryWidget.widget_type === "Image") {
    const topImageSet = media && media[primaryWidget.media_id] || [];

    if (!topImageSet.artefacts || topImageSet.artefacts.length === 0) {
      return null;
    }

    return (
      <div className="news-article-image">
          <span>
            <Image
              imageMedia={topImageSet}
              imageType="articlePage"
            />
          </span>
      </div>
    )
  }

  if (primaryWidget.widget_type === "Video") {
    return (
      <div className="ooyala-hero-image">
        <Ooyala contentId={primaryWidget.media_id}/>
      </div>
    )
  }

  return null;
};
ArticleHeroImage.propTypes = {
  widgets: PropTypes.arrayOf(PropTypes.shape({
    widget_type: PropTypes.string,
    keys: PropTypes.array,
  })),
  media: PropTypes.object,
  articleId: PropTypes.string.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const {article: articles, media} = state.common;
  const article = get(articles, `${ownProps.articleId}.article`, {});

  return {
    widgets: article.widgets || [],
    media,
  };
}

export default withErrorBoundary(connect(mapStateToProps)(ArticleHeroImage));



// WEBPACK FOOTER //
// ./modules/News/components/ArticleHeroImage.js